import { useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import WhiteBoard from "src/components/WhiteBoard";
import { Formik, Form, Field, ErrorMessage } from "formik";
import FormikField from "src/components/FormikField/FormikField";
import TwinButton from 'src/components/TwinButton';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";

export default function Limitation() {
    const [whiteList, setWhiteList] = useState()
    const [whiteListOptions, setWhiteListOptions] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [users, setUsers] = useState()
    const [userOptions, setUserOptions] = useState()

    useEffect(() => {
        getData((data) => {
            setWhiteList(JSON.parse(data))
        }, "/option/whiteListIPs")
        getData((data) => {
            setUserOptions(data.map(user => {
                return {
                    value: user.id,
                    label: user.fullName
                }
            }))
        }, "/users")
    }, [])

    useEffect(() => {
        if (whiteList) {
            setWhiteListOptions(whiteList.map(ip => {
                return {
                    value: ip,
                    label: ip
                }
            }))
        }
    }, [whiteList])

    useEffect(() => {
        if (userOptions) {
            getData((data) => {
                setUsers(userOptions.filter(option => {
                    if (JSON.parse(data).includes(option.value)) {
                        return option
                    }
                }))
            }, "/option/whiteListUserIDs")
        }
    }, [userOptions])



    return (
        <>
            <PageHeader
                title="مدیریت دسترسی"
            />
            <WhiteBoard>
                <div className='w-full flex flex-col gap-4 p-6 border border-gray-100 rounded-xl'>
                    <div className='flex flex-col gap-2 text-center'>
                        <span className='text-xl font-bold'>لیست IP های مجاز</span>
                        <span className='text-sm '>موارد انتخاب شده IPهایی هستند که مجوز دسترسی به داشبورد را دارند</span>
                    </div>

                    <CreatableSelect
                        value={whiteListOptions}
                        isClearable
                        // defaultValue={[whiteListOptions?.[2], whiteListOptions?.[3]]}
                        isMulti
                        name="whiteListIPs"
                        className="al-dashboard"
                        options={whiteListOptions}
                        onChange={(selectedOption) => { setWhiteListOptions(selectedOption) }}
                        placeholder="آی پی هایی که دسترسی از طریق آن‌ها امکان پذیر است را وارد کنید..."
                    />
                    <TwinButton
                        acceptTitle='ذخیره تغییرات'
                        rejectTitle={false}
                        isCompact={true}
                        isLoading={isLoading}
                        acceptHandle={async () => {
                            setIsLoading(true)
                            let neccessaryIPs = ["195.28.168.91", "93.118.147.178", "5.144.131.250", "::1"]

                            let result = await post("/option/whiteListIPs", {
                                data: JSON.stringify([...new Set([...neccessaryIPs, ...whiteListOptions.map(ip => ip.value)])])
                            })
                            if (result.success) {
                                notify("تغییرات با موفقیت انجام شد")
                            }
                            setIsLoading(false)
                        }}
                    />
                </div>
                <div className='w-full flex flex-col gap-4 p-6 border border-gray-100 rounded-xl'>
                    <div className='flex flex-col gap-2 text-center'>
                        <span className='text-xl font-bold'>لیست بدون محدودیت IP کاربران</span>
                        <span className='text-sm '>کاربران انتخاب شده کاربرانی هستند که بدون محدودیت IP امکان دسترسی به داشبورد را دارند</span>
                    </div>

                    <Select
                        value={users}
                        isClearable
                        // defaultValue={[whiteListOptions?.[2], whiteListOptions?.[3]]}
                        isMulti
                        name="whiteListIPs"
                        className="al-dashboard"
                        options={userOptions}
                        onChange={(selectedOption) => { setUsers(selectedOption) }}
                        placeholder="کاربرانی که دسترسی آن‌ها بدون محدودیت آی پی است را وارد کنید..."
                    />
                    <TwinButton
                        acceptTitle='ذخیره تغییرات'
                        rejectTitle={false}
                        isCompact={true}
                        isLoading={false}
                        acceptHandle={async () => {
                            let result = await post("/option/whiteListUserIDs", {
                                data: JSON.stringify(users.map(user => {
                                    return user.value
                                }))
                            })
                            if (result.success) {
                                notify("تغییرات با موفقیت انجام شد")
                            }
                        }}
                    />
                </div>
            </WhiteBoard>
        </>
    )
}
